<template>
    <div class="quick-filters">
        <button
            v-for="tab in visibleTabs"
            :key="tab.key"
            type="button"
            class="quick-filters__item"
            :class="{ 'quick-filters__item_active': activeScope === tab.key }"
            @click.stop="onTabClick(tab.key)"
        >
            {{ tab.label }}
            <span class="quick-filters__count" v-if="countFor(tab.key) !== null">{{ countFor(tab.key) }}</span>
        </button>
    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component()
class RequestQuickFilters extends Vue {
    @Prop({ type: String, default: 'all' }) activeScope;
    @Prop({ type: Object, default: null }) counts;
    @Prop({ type: Boolean, default: false }) showUnassigned;

    // Вкладка «Без исполнителя» доступна только во «Входящих»; остальные разделы
    // сохраняют прежний набор быстрых фильтров.
    allTabs = [
        { key: 'all', label: 'Все' },
        { key: 'my', label: 'Мои' },
        { key: 'observing', label: 'Наблюдаю' },
        { key: 'today', label: 'Сегодня' },
        { key: 'unassigned', label: 'Без исполнителя' },
    ];

    get visibleTabs() {
        return this.showUnassigned ? this.allTabs : this.allTabs.filter((tab) => tab.key !== 'unassigned');
    }

    countFor(key) {
        if (!this.counts) return null;
        const value = this.counts[key];
        return value === undefined || value === null ? null : value;
    }

    onTabClick(key) {
        this.$emit('filter-by-scope', key);
    }
}

export default RequestQuickFilters;
</script>

<style lang="scss">
.quick-filters {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    padding: 4px 0;
    margin-bottom: 6px;
    font-size: 0.9rem;

    &__item {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        white-space: nowrap;
        cursor: pointer;
        border: none;
        background: transparent;
        color: #3c4043;
        padding: 6px 12px;
        border-radius: 8px;
        font-size: 0.9rem;
        font-weight: 500;
        line-height: 1;
        transition: background 0.15s, color 0.15s;

        &:hover {
            background: #f6f7f8;
        }
    }

    &__count {
        font-size: 0.75rem;
        font-weight: 600;
        color: #9aa0a6;
    }

    &__item_active {
        background: #e8f5e9;
        color: #2e7d32;
        font-weight: 600;

        .quick-filters__count {
            color: #2e7d32;
        }
    }
}
</style>
